export const LIFE_INDEX_QUERY_KEY = ["me", "life"] as const;

export const NO_PROFILE_LINE =
  "We do not have your birth details yet. Add them and these readings open up.";
